import type {
  ConsentType,
  GetConsentGroupResponse,
  GetConsentResponse,
} from '@integration/api-client/consent';

export const getFlatGroupConsents = (consentGroup: GetConsentGroupResponse) =>
  consentGroup.sub_groups.flatMap((subGroup) => subGroup.consents);

export const getFlatConsents = (consentGroups: GetConsentGroupResponse[]) =>
  consentGroups.flatMap(getFlatGroupConsents);

export const getConsent = (
  consentGroups: GetConsentGroupResponse[],
  consentType: ConsentType
): GetConsentResponse | undefined =>
  getFlatConsents(consentGroups).find(
    (consent) => consent.consent_type === consentType
  );
